export function getPublicId(url: string): string | undefined {
  if (!url) return;
  const [, publicId] = url.match(/upload\/(?:v\d+\/)?([^.]+)/) || [];
  return publicId;
}
